import * as actionTypes from './actionTypes';
import reduce from '../reduce';

const initialState = {
    workers: [],
    count: 0,
    page: 1,
    pageSize: 5,
    pages: 0,
    sortField: 'created_at',
    sortOrder: 'desc',
    search: null,
    error: '',
    anyChanges: false,
    openAddOrEditForm: false,
    worker: null,
    isEditWorker: false
}

const receivedWorkersData=(state, action)=>{
    const { results,count,page,pageSize,pages,sortField,sortOrder,search } = action.data;
    return {
        ...state,
        workers: results,
        count: count,
        page: page,
        pageSize: pageSize,
        pages: pages,
        sortField: sortField,
        sortOrder: sortOrder,
        search: search,
        anyChanges: false
    }
}

const getWorkersError=(state, action)=> {
    return {
        ...state,
        error: action.error
    }
}

const newWorkerCreated=(state)=>{
    return {
        ...state,
        anyChanges: true,
        error: ''
    }
}

const newWorkerCreateError=(state,action)=>{
    return {
        ...state,
        error: action.error
    }
}

const workerUpdated=(state)=>{
    return {
        ...state,
        anyChanges: true,
        error: ''
    }
}

const workerUpdateError=(state,action)=>{
    return {
        ...state,
        error: action.error
    }
}

const openedAddOrEditForm=(state)=>{
    return {
        ...state,
        openAddOrEditForm: true,
        isEditWorker: false,
        worker: null,
        error: ''
    }
}

const canceledAddOrEditForm=(state)=>{
    return {
        ...state,
        openAddOrEditForm: false,
        isEditWorker: false
    }
}

const selectedAWorker=(state,action)=>{
    return {
        ...state,
        worker: action.worker,
        isEditWorker: true,
        openAddOrEditForm: true
    }
}

export default reduce(initialState,{
    [actionTypes.GET_WORKERS_DATA]: receivedWorkersData,
    [actionTypes.GET_WORKERS_DATA_ERROR]: getWorkersError,
    [actionTypes.OPEN_ADD_OR_EDIT_FORM]: openedAddOrEditForm,
    [actionTypes.CANCEL_ADD_OR_EDIT_FORM]: canceledAddOrEditForm,
    [actionTypes.NEW_WORKER_CREATED]: newWorkerCreated,
    [actionTypes.NEW_WORKER_CREATE_ERROR]: newWorkerCreateError,
    [actionTypes.WORKER_UDPATED]: workerUpdated,
    [actionTypes.WORKER_UDPATE_ERROR]: workerUpdateError,
    [actionTypes.SELECTED_A_WORKER]: selectedAWorker
});


// WEBPACK FOOTER //
// ./src/redux/worker/reducer.js